<template>
  <v-container>
    <ReferenceSearchTab :search="search" v-on:search="performSearch" :open-dialog="editDialog"
                        v-on:open-create="createItem" :objectName="objectName"></ReferenceSearchTab>
    <EditDialog v-bind:open-dialog="editDialog" v-on:close-dialog="closeDialog()" :objectType="objectType"
                :record="record" :imgName="imgName" v-on:save-record="saveRecord($event)" :action="action"
                v-on:create-record="createRecord($event)"></EditDialog>
    <v-data-table
      :loading="loading"
      dense
      item-key="topicId"
      loader-height="5"
      :loading-text="$t('loadings.loading-topics')"
      :no-data-text="$t('loadings.no-topics-found')"
      multi-sort
      :headers="headers"
      :items="topics"
      :search="search"
      :footer-props="{
                showFirstLastPage: true,
                itemsPerPageOptions: [ 5, 10, 15, 50, -1]}">
      <template v-slot:item.isActive="{ item }">
        <v-switch inset v-on:change="activateItem(item.topicId, item.active)"
                  v-model="item.active">
        </v-switch>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  import ReferenceSearchTab from "./ReferenceSearchTab";
  import EditDialog from "./reference-dialogs/EditDialog";
  import {AXIOS} from "../../../http-commons";

  let moment = require('moment');
  export default {
    components: {ReferenceSearchTab, EditDialog},
    props: ['topics', 'loading'],
    name: "TopicsTab",
    methods: {
      performSearch(searchValue) {
        this.search = searchValue
      },
      closeDialog() {
        this.editDialog = false
      },
      editItem(item) {
        this.editDialog = true
        this.objectType = 'topic'
        this.imgName = 'editTopicDialog.jpg'
        this.record = item
        this.action = 'edit'
      },
      createItem() {
        this.editDialog = true
        this.objectType = 'topic'
        this.imgName = 'editTopicDialog.jpg'
        this.action = 'create'
      },
      activateItem(topicId, active) {
        let params = new URLSearchParams();
        let action = active ? 'activate' : 'deactivate';
        params.append('topicId', topicId);
        params.append('isActive', active);
        AXIOS.put(`/api/activateTopic`, params)
          .then(response => {
            this.userNotification(response.data, action, this.objectName);
          })
      },
      saveRecord(record) {
        let action = 'update';
        let params = new URLSearchParams();
        params.append('topicId', record.topicId);
        params.append('topicName', record.topicName);
        params.append('description', record.description);
        params.append('active', record.active);
        params.append('deleted', record.deleted);
        AXIOS.put(`/api/updateTopic`, params)
          .then(response => {
            this.editDialog = false;
            this.userNotification(response.data, action, this.objectName);
          })
      },
      createRecord(record) {
        let action = 'create';
        let params = new URLSearchParams();
        params.append('topicName', record.topicName);
        params.append('description', record.description);
        params.append('userId', this.currentUser.id);
        AXIOS.post(`/api/createTopic`, params)
          .then(response => {
            this.editDialog = false;
            this.userNotification(response.data, action, this.objectName);
            this.getNewRecord(response.data.topicId)
          })
      },
      getNewRecord(id) {
        let params = new URLSearchParams();
        params.append('topicId', id);
        params.append('userId', this.currentUser.id);
        AXIOS.get('/api/getTopicById', {params})
          .then(response => {
            let record = response.data;
            this.topics.push(record)
          })
      },
    },
    data() {
      return {
        objectName: 'Topic',
        action: '',
        editDialog: false,
        objectType: '',
        imgName: '',
        record: null,
        search: '',
        headers: [
          {
            text: this.$t('tables.active'),
            align: 'start',
            value: 'isActive',
            class: "primary--text",
          },
          {
            text: this.$t('tables.topicName'),
            value: 'topicName',
            class: "primary--text",
          },
          {text: this.$t('tables.description'), value: 'description', class: "primary--text"},
          {text: this.$t('tables.actions'), value: 'actions', class: "primary--text", sortable: false},
        ],
      }
    },
  }
</script>

<style scoped>

</style>
